import formatInTimeZone from 'date-fns-tz/formatInTimeZone';

/** Get time zone from the user location */
export const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

/**
 * Parse date based on time zone
 * @see https://github.com/marnusw/date-fns-tz#formatintimezone
 */
export const parseDateInTimeZone = (date: Date, time_zone: string, formatStr: string) => {
    // eslint-disable-next-line quotes
    const dateInTimeZone = formatInTimeZone(date, time_zone, formatStr);
    return dateInTimeZone;
};

/**
 * Parse date based on the locale and time zone
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
 */
export const parseLocaleStringInTimeZone = (date: Date, locales?: Intl.LocalesArgument, time_zone?: string) => {
    const localeStringInTimeZone = date.toLocaleString(locales, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: time_zone,
        timeZoneName: 'short'
    });
    return localeStringInTimeZone;
};

export const getUnixTimestamp = (date: Date | string | number) => {
    if (!date) return undefined;
    const unixTimestamp = Math.floor(new Date(date).getTime());
    return unixTimestamp;
};

/**
 * Add an determined amount of hours to a date
 */
export const addMinutes = (date: Date, minutes: number = 0): Date => {
    const milleseconds = minutes * 60_000;
    const newDateTime = date.getTime() + milleseconds;
    const newDate = new Date(newDateTime);

    return newDate;
};

export const getUTCTimeZoneOffset = () => {
    const today = new Date();
    const sign = today.getTimezoneOffset() > 0 ? '-' : '+';
    const offset = Math.abs(today.getTimezoneOffset());
    const hours = Math.floor(offset / 60)
        .toString()
        .padStart(2, '0');
    const minutes = (offset % 60).toString().padStart(2, '0');
    return `${sign + hours}:${minutes}`;
};

/**
 *
 * @param datetimeString must be formatted as "YYYY-MM-DD hh:mm"
 *
 * @returns UTC ISO string in the format "YYYY-MM-DDThh:mm:ss.sssZ"
 */
export const getISOStringFromString = (datetimeString: String) => {
    const dateComponents = datetimeString.split(/[\s-:]/);
    const dateObjectUTC = new Date(
        Date.UTC(
            parseInt(dateComponents[0], 10),
            parseInt(dateComponents[1], 10) - 1, // 0-index
            parseInt(dateComponents[2], 10),
            parseInt(dateComponents[3], 10),
            parseInt(dateComponents[4], 10)
        )
    );

    return dateObjectUTC.toISOString();
};
